import React, { useEffect, useState } from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter, Routes, Route } from "react-router-dom";
import './index.css';
import reportWebVitals from './reportWebVitals';
import { store, persistor } from './store';
import { Provider, useSelector, useDispatch } from 'react-redux';
import { PersistGate } from 'redux-persist/integration/react';

import MainLayout from "./layouts/MainLayout";
import Home from "./pages/Home";
import NoPage from "./pages/NoPage";
import LoginPage from './pages/LoginPage';
import LoginAutoPage from './pages/LoginAutoPage';
import Dispatch from './pages/Dispatch';
import MRMSMapPage from './pages/MRMSMapPage';
import CallTaker from './pages/CallTaker.js';
import RouteChart from './pages/RouteChartView';
import { resetConfiguration, resetGridRefreshConfiguration } from './features/common/configurationSlice';
import APICom from './utils/helpers/APICom';
import { SetCombineData, SetLoading } from './features/common/combinedataSlice';
import PersistStorage from './utils/helpers/PersistStorage';
import DemoMTSchedulerLayout from './layouts/DemoMTSchedulerLayout.js';
import MicroTransitMySimulation from './pages/MicroTransitMySimulation';
import NearbyStopsFinderSimulation from './pages/NearbyStopsFinderSimulation.js'
import Communicator from './components/Controls/Communicator.js';
import ManifestSetting from './pages/ManifestSetting.js';
import ZoneSpeedMultiplierComponent from "./pages/SpeedZoneMultiplier.js";
import Messaging from './components/Controls/Messaging.js';

import DriverRouteMessaging from './components/Dispatch/AdminFunctions/DriverRouteMessaging.js';
import CustomerManagement from './pages/Customer/CustomerManagement.js';
import Notificationlogs from './components/Dispatch/AdminFunctions/Notificationlogs.js';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import AppWrapper from './AppWrapper';

export default function Index() {
    const { ConfigurationsLoaded, CurrentApplicationVersion } = useSelector((store) => store.configuration);
    const { loginData } = useSelector((store) => store.login);
    const [childAffiliate, setChildAffiliate] = useState(0);
    const dispatch = useDispatch();

    const handleAffChange = (data) => {
        try {
            setChildAffiliate(data);
            PersistStorage.save("affSelectedCallAgent", data, 999, true);
            // console.log("Dispatch Data", data);
        }
        catch (err) { console.log(err); }
    };

    const handleRowSelection = (data) => {
        try {
            // console.log(data);
            if (data && data.length > 0) {
                PersistStorage.save("rowDataCallAgent", data, 999, true);
            }
            else {
                PersistStorage.save("rowDataCallAgent", [], 999, true);
            }
        }
        catch (err) { console.log(err); }
    };

    useEffect(() => {
        dispatch(resetConfiguration());
        dispatch(resetGridRefreshConfiguration());
        // let _CurrentAppVersion = process.env.version;
        // if (ConfigurationsLoaded === false || CurrentApplicationVersion !== _CurrentAppVersion) {
        //     dispatch(resetConfiguration());
        // }
        const fetchAndStoreCombineData = async (e) => {
            try {
                let vUserAssignedAffiliates = "-1";
                dispatch(SetLoading(true));
                var response = await APICom.fetchData("AspDotNetCoreURL", "CombinedData/GetCombinedDataByAffiliateIDs?vAffiliateIds=" + vUserAssignedAffiliates, "get", {}, {});
                response = JSON.parse(response.data);
                dispatch(SetCombineData({ data: response["FamilyData"], name: "FamilyData" }));
                dispatch(SetCombineData({ data: response["AffiliateData"], name: "AffiliateData" }));
                dispatch(SetCombineData({ data: response["MvRouteSettingData"], name: "MvRouteSettingData" }));
                dispatch(SetCombineData({ data: response["BrokerServingAffiliatesData"], name: "BrokerServingAffiliatesData" }));
                dispatch(SetCombineData({ data: response["FundingSourceData"], name: "FundingSourceData" }));
                dispatch(SetCombineData({ data: response["ASCSSettingData"], name: "ASCSSettingData" }));
                dispatch(SetCombineData({ data: response["CancelReasonData"], name: "CancelReasonData" }));
                dispatch(SetCombineData({ data: response["NoShowReasonData"], name: "NoShowReasonData" }));
                dispatch(SetCombineData({ data: response["DispatchDriverData"], name: "DispatchDriverData" }));
                dispatch(SetCombineData({ data: response["DispatchVehicleData"], name: "DispatchVehicleData" }));
                dispatch(SetCombineData({ data: response["BrokerCancelReasonData"], name: "BrokerCancelReasonData" }));
                dispatch(SetCombineData({ data: response["VehicleInfoData"], name: "VehicleInfoData" }));
                dispatch(SetCombineData({ data: response["AttributeData"].Table, name: "AttributeData" }));
                dispatch(SetCombineData({ data: response["GlobalASCSData"], name: "GlobalASCSData" }));
                dispatch(SetCombineData({ data: response["ZoneVerticesData"], name: "ZoneVerticesData" }));
                dispatch(SetCombineData({ data: response["VirtualStopsData"], name: "VirtualStopsData" }));
                dispatch(SetCombineData({ data: response["ClassOfServiceData"], name: "ClassOfServiceData" }));
                dispatch(SetCombineData({ data: response["PaymentTypesData"], name: "PaymentTypesData" }));
                dispatch(SetCombineData({ data: response["RCZZoneVerticesData"], name: "RCZZoneVerticesData" }));
                dispatch(SetCombineData({data: response["ZoneSpeedMultiplier"], name:"ZoneSpeedMultiplier"}));
                dispatch(SetCombineData({ data: response["VehicleTypesPerAffiliateData"], name: "VehicleTypesPerAffiliateData" }));
                dispatch(SetCombineData({ data: response["OARAAlarmStatusData"], name: "OARAAlarmStatusData" }));
                dispatch(SetLoading(false));

            }
            catch (e) { console.log(e); dispatch(SetLoading(false)); }
        };
        fetchAndStoreCombineData();
    }, [dispatch]);


    ///////////////////////////////////////////
    // add a path for driver route messaging //
    ///////////////////////////////////////////
    return (
        <BrowserRouter>
            <Routes>
                <Route path="/" element={<MainLayout affSelected={childAffiliate} />}>
                    <Route path="Login" element={<LoginPage />} />
                    <Route path="LoginAuto" element={<LoginAutoPage />} />
                    <Route path="Home" element={<Home />} />
                    <Route path="Dispatch" element={<Dispatch sendAffToParent={handleAffChange} gridRowData={handleRowSelection} />} />
                    <Route path="MapPage" element={<MRMSMapPage />} />
                    <Route path="ManifestSetting" element={<ManifestSetting />} />
                    <Route path="CallAgent" element={<CallTaker />} />
                    <Route path="routeschart" element={<RouteChart />} />
                    <Route path="Messaging" element={<Messaging />} />
                    <Route path="DriverRouteMessaging" element={<DriverRouteMessaging />} />
                    <Route path="Notificationlogs" element={<Notificationlogs />} />
                    <Route path="CustomerManagement" element={<CustomerManagement />} />
                    <Route path="*" element={<NoPage />} />
                </Route>
                <Route path="/simulationscheduler" element={<DemoMTSchedulerLayout />} />
                <Route path="/mysimulation" element={<MicroTransitMySimulation />} />
                <Route path="/microtransitsimulation" element={<NearbyStopsFinderSimulation />} />
                <Route path="/Communicator" element={<Communicator />} />
                <Route path="/ZoneSpeedMultiplier" element={<ZoneSpeedMultiplierComponent />} />
            </Routes>
            <ToastContainer position="bottom-right" autoClose={3000} />
        </BrowserRouter>
    );
}

const container = document.getElementById("root");
//const root = ReactDOM.createRoot(document.getElementById('root'));
if (!container.__reactRoot) {
    container.__reactRoot = ReactDOM.createRoot(container);
}

container.__reactRoot.render(
    <Provider store={store}>
        <PersistGate loading={null} persistor={persistor}>
            {/* <AppWrapper> */}
                <Index/>
            {/* </AppWrapper> */}
        </PersistGate>
    </Provider>
);
// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
